import styled from 'styled-components';
import { styleSheet } from '../../assets/styles/global';

interface ProdutoHeaderProps {
  isOpen: boolean;
}

export const ProdutoContainer = styled.div`
  width: 90%;
  /* height: 750px; */
  margin: 0 auto;
  margin-top: 30px;

  background-color: ${styleSheet.shape};

  /* border: 0.5px solid ${styleSheet.colorMain}; */
  border-radius: 8px;
`;

export const ProdutoTitle = styled.div`
  display: flex;
  align-items: center;
`;

export const ProdutoIcon = styled.img`
  width: 45px;
  height: 45px;
`;

export const ProdutoText = styled.h3`
  color: ${styleSheet.shape};

  font-size: 2rem;
  font-weight: 600;

  line-height: 41px;
  margin: 0;
  margin-left: 30px;

`;